<template>
    <a :href="filter_item.fl_url"
        class="value-link d-flex justify-content-between" :class="{
      selected: filter_item.selected,
      subSelected: filter_item.fl_isParentCategory && !filter_item.selected
    }">
      {{ filter_item.value }} <span class="frequency" v-if="filter_item.frequency > 0">({{ filter_item.frequency }})</span>
    </a>
</template>

<script>
export default {
  name: "value_link",
  props: ['filter_item'],
}
</script>

<style scoped>

.value-link {
  margin: 7px 25px 7px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.value-link.selected {
  font-weight: bold;
}

.value-link.subSelected {
  font-weight: bold;
}

.frequency {
  font-size: 0.8rem;
  white-space: nowrap;
  margin: auto 0;
}
</style>
